




function initColors()
{
    var colors = document.querySelectorAll("input.product-block__color_radio");
    for(var i = 0; i < colors.length; i++)
    {
        colors[i].addEventListener("change", function(e) {
            var parent = e.target;
            while (parent.querySelector("a img") == null)
                parent = parent.parentElement;
            if (parent.querySelector("a img") != null)
            {
              console.log("updated");
                var img = parent.querySelector("a img");
                img.closest("a").setAttribute("href", e.target.getAttribute("data-variant-url"));
                img.setAttribute("src", e.target.getAttribute("data-image-url"));
                img.removeAttribute("srcset");
                /*
                var img2 = document.createElement("img");
                img2.classList = img.classList;
                img2.setAttribute("src", e.target.getAttribute("data-image-url"));
                img.parentElement.appendChild(img2);
                img.remove();
                */
            }
            while (parent.querySelectorAll("a").length < 2)
                parent = parent.parentElement;
            if (parent.querySelectorAll("a").length == 2)
                parent.querySelectorAll("a")[1].setAttribute("href", e.target.getAttribute("data-variant-url"));
        });
    }
}
document.addEventListener("DOMContentLoaded", function() {
  initColors();
  /*document.querySelector("div[data-components]").addEventListener("cc:component:load", function(e) {
    console.log(e);
    initColors();
  });*/
});
